import { Conference, Content } from "./types";
import { Enum_ContentQualityPreference } from "generated/graphql";
import { mixedEnum, object } from "./helpers";

export const content = object<Content>({
  conference: object<Conference>({
    qualityPreference: mixedEnum(
      Enum_ContentQualityPreference,
      "QUALITY_PREFERENCE"
    ).default(Enum_ContentQualityPreference.Both)
  })
});
